/**
 * Gift Set Goal Paywall — EdgenModal 外壳（Figma H5 `96138:32739` / card `96097:351742`）。
 *
 * 图二是居中浮层卡片（非全屏 Drawer）：
 * - `centered: true` → H5/PC 都走 OspModal，靠 Modal mask 做半透明遮罩
 * - 内容区只渲染卡片本身，外壳保持透明，不要铺 secondary 实底
 *
 * | 端 | 宽     | 高   | 圆角 | 关闭             |
 * |----|--------|------|------|------------------|
 * | H5 | 345px  | auto | 12px | 无关闭（仅 CTA） |
 * | PC | 400px  | auto | 12px | 无关闭（仅 CTA） |
 */

export const GIFT_SET_GOAL_PAYWALL_MODAL_H5_WIDTH_PX = 345;
export const GIFT_SET_GOAL_PAYWALL_MODAL_PC_WIDTH_PX = 400;
export const GIFT_SET_GOAL_PAYWALL_MODAL_PC_HEIGHT_PX = 606;
export const GIFT_SET_GOAL_PAYWALL_MODAL_PC_RADIUS_PX = 12;

/** 叠在 Paywall（1100）之上，避免关 Paywall 后瞬时被盖住 */
export const GIFT_SET_GOAL_PAYWALL_MODAL_Z_INDEX = 1110;

export const GIFT_SET_GOAL_PAYWALL_MODAL_PROPS = {
  centered: true,
  zIndex: GIFT_SET_GOAL_PAYWALL_MODAL_Z_INDEX,
  className:
    "[--modal-radius:12px] [--modal-width:345px] md:[--modal-width:400px]",
  contentStyle: {
    borderRadius: "var(--modal-radius)",
    width: "var(--modal-width)",
    maxWidth: "calc(100vw - 48px)",
    height: "auto",
    overflow: "hidden" as const,
    padding: 0,
    background: "transparent",
  },
  styles: {
    body: {
      padding: 0,
      background: "transparent",
    },
  },
  containerStyle: {
    width: "100%",
    background: "transparent",
  },
  titleStyle: {
    minHeight: 0,
  },
  showClose: false,
  maskClosable: false,
  destroyOnClose: true,
} as const;
